// interface
import { BasicDetailsTypes } from '../../../data/myProfile';

interface UserDescriptionProps {
    basicDetails: BasicDetailsTypes;
}
const UserDescription = ({ basicDetails }: UserDescriptionProps) => {
    return (
        <>
            {/* <div className="text-muted">
                <p className="mb-4">
                    {basicDetails && basicDetails.description
                        ? basicDetails.description
                        : '-'}
                </p>
            </div> */}

            <div>
                <div className="d-flex py-2">
                    <div className="flex-shrink-0 me-3">
                        <i className="bx bx-user align-middle text-muted"></i>
                    </div>
                    <div className="flex-grow-1">
                        <p className="mb-0">
                            {basicDetails?.person.displayName
                                ? basicDetails?.person.displayName
                                : `${basicDetails?.person.firstName} ${basicDetails?.person.lastName}`}
                        </p>
                    </div>
                </div>

                <div className="d-flex py-2">
                    <div className="flex-shrink-0 me-3">
                        <i className="bx bx-message-rounded-dots align-middle text-muted"></i>
                    </div>
                    <div className="flex-grow-1">
                        <p className="mb-0">
                            {basicDetails && basicDetails.person.email
                                ? basicDetails.person.email
                                : '-'}
                        </p>
                    </div>
                </div>

                <div className="d-flex py-2">
                    <div className="flex-shrink-0 me-3">
                        <i className="bx bx-phone align-middle text-muted"></i>
                    </div>
                    <div className="flex-grow-1">
                        <p className="mb-0">
                            {basicDetails && basicDetails.person.phoneNumber
                                ? basicDetails.person.phoneNumber
                                : '-'}
                        </p>
                    </div>
                </div>
            </div>
        </>
    );
};

export default UserDescription;
